import $ from 'jquery';
import RevealWhenVisible from '../../components/reveal-when-visible';
import VideoModalButton from '../../components/video-modal-button';
$(() => {
    VideoModalButton.init();
    RevealWhenVisible.init();
});
